import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { Add } from '@mui/icons-material';
import { Box, Button, IconButton, LinearProgress, Tooltip } from "@mui/material";
import { DataGridPro, GridColDef, GridToolbarFilterButton } from '@mui/x-data-grid-pro';
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { config } from "../../Constants";
import useAuth from "../../context/AuthProvider";
import { StatesZeroFilingRuleModel } from "../../models/StatesZeroFilingRuleModel";
import { EditStateZeroFilingRuleMatrix } from "../AddEdit/EditStateZeroFiling";
import { RiExpandUpDownLine } from "react-icons/ri";
import { apiClient } from '../../helper/api';
import { KeyboardArrowUp } from '@mui/icons-material';
import { KeyboardArrowDown } from '@mui/icons-material';

interface Iprops {
    StateZeroFilingRuleCL: StatesZeroFilingRuleModel[],
    fetchData: () => void,
    sortModel: any;
    setSortModel: React.Dispatch<React.SetStateAction<any>>;
}

export const StateZeroFilingRuleList: React.FC<Iprops> = ({ StateZeroFilingRuleCL, fetchData, sortModel, setSortModel }) => {
    const [loading, setloading] = useState(false);
    const { user } = useAuth();
    const token = user?.token;

    const initialLBData: StatesZeroFilingRuleModel = {
        stateId: "",
        name: "",
        postalAbbv: "",
        standardAbbv: "",
        isElectronicSignature: false,
        isZeroFilingState: false
    }

    const [Open, setOpen] = React.useState(false);
    const [Formdata, setFormData] = React.useState(initialLBData);
    const navigate = useNavigate();
    const goBack = () => {
        navigate(-1);
    }

    const handleClose = () => {

        setOpen(false);
    };
    const handleSubmit = () => {
        fetchData();
        setOpen(false);
    };
    const handleClickOpen = () => {
        setFormData(initialLBData);
        setOpen(true);
    };

    const handleEdit = (ILobData: StatesZeroFilingRuleModel) => {

        console.log("editData",ILobData)
        
        setFormData(ILobData);
        setOpen(true);
    };

    const handleDelete = (id: number) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            // icon: null, // Remove the icon property
            iconHtml: '<svg width="70" height="70" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="31" cy="31" r="31" fill="#02A4E3"/><path d="M31.0003 25.6667V31M31.0003 36.3334H31.0137M44.3337 31C44.3337 38.3638 38.3641 44.3334 31.0003 44.3334C23.6365 44.3334 17.667 38.3638 17.667 31C17.667 23.6362 23.6365 17.6667 31.0003 17.6667C38.3641 17.6667 44.3337 23.6362 44.3337 31Z" stroke="white" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
            showCancelButton: true,
            confirmButtonColor: '#02A4E3',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Delete',
            customClass: {
                confirmButton: 'btn-radius',
                cancelButton: 'btn-radius',
                popup: 'card-radius'
            }
        })
            .then((result) => {
                if (result.isConfirmed) {
                    apiClient("/StatesZeroFilingRules/Delete?id=" + `${id}`,
                        {
                            headers: new Headers({
                                'Content-Type': 'application/json',
                                'Authorization': `Bearer ${token}`,
                            }),
                            method: "Delete",
                        }
                    )
                        .then((res) => {
                            if (!res) return
                            Swal.fire(
                                'Deleted!',
                                'Your file has been deleted.',
                                'success'
                            )
                            fetchData();
                            setOpen(false);
                        })
                  
                }
            })
        //call api to save data
        // fetch(config.url.API_URL + "/Users/Delete?id=" + `${id}`,
        //     {
        //         headers: new Headers({
        //             'Content-Type': 'application/json',
        //             'Authorization': `Bearer ${token}`,
        //         }),
        //         method: "Delete",
        //     }
        // )
        //     .then((response) => {
        //         if (response.ok) {
        //             return response.json();
        //         }
        //         throw new Error('Something went wrong');
        //     })
        //     .then((res) => {
        //         alert("Data Successfully Deleted")
        //         fetchData();
        //         setOpen(false);
        //     }).catch((error) => {
        //         console.log(error)
        //     });


    };

    function EditToolbar() {
        return (
            <Box sx={{
                borderBottom: 1,
                borderColor: 'divider',
                p: 1,
            }}>
                <GridToolbarFilterButton />
            </Box>
        );
    }




    const columns: GridColDef[] = [

        { field: 'name', type: 'text', headerName: 'State Name', align: 'left',hideSortIcons: true,
        renderHeader: (params) => {
            const sortItem = sortModel.find(
                (item: any) => item.field === 'name'
              );
          
              const isSortedAsc = sortItem?.sort === 'asc';
              const isSortedDesc = sortItem?.sort === 'desc'
              return (
            <div>
                <span className="table-card-title" >{params.colDef.headerName}</span>
                {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
            </div>
        )}, headerAlign: 'left', flex: 1 },


        { field: 'postalAbbv', type: 'text', headerName: 'Postal Abbv.', align: 'left',hideSortIcons: true,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'postalAbbv'
                  );
              
                  const isSortedAsc = sortItem?.sort === 'asc';
                  const isSortedDesc = sortItem?.sort === 'desc'
                  return (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                    {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                </div>
            )}, headerAlign: 'left', flex: 1 },
        { field: 'standardAbbv', type: 'text', headerName: 'Standard Abbv', align: 'left',hideSortIcons: true,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'standardAbbv'
                  );
              
                  const isSortedAsc = sortItem?.sort === 'asc';
                  const isSortedDesc = sortItem?.sort === 'desc'
                  return (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                    {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                </div>
            )}, headerAlign: 'left', flex: 1 },
        {
            field: 'isElectronicSignature', type: 'boolean', headerName: 'Electronic Signature',hideSortIcons: true,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'isElectronicSignature'
                  );
              
                  const isSortedAsc = sortItem?.sort === 'asc';
                  const isSortedDesc = sortItem?.sort === 'desc'
                  return (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                    {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                </div>
            )}, align: 'left', headerAlign: 'left', flex: 1,
            renderCell: (params) => (
                <div>
                    {
                        params.row.isElectronicSignature == false ? "Electronic Signature Not Ok" : "Electronic Signature Ok"
                    }
                </div>
            )

        },
        {
            field: 'isZeroFilingState', type: 'boolean', headerName: 'Zero Filing State', align: 'left',hideSortIcons: true,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'isZeroFilingState'
                  );
              
                  const isSortedAsc = sortItem?.sort === 'asc';
                  const isSortedDesc = sortItem?.sort === 'desc'
                  return (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                    {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                </div>
            )}, headerAlign: 'left', flex: 1,
            renderCell: (params) => (
                <div>
                    {
                        params.row.isZeroFilingState == false ? "NO" : "Yes"
                    }
                </div>
            )
        },
        {
            field: 'stateRuleMatrixId', flex: 1, headerName: "Edit/Delete", align: 'center', headerAlign: 'center', hideSortIcons: true, sortable: false, disableColumnMenu: true,
            renderHeader: (params) => (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                    <RiExpandUpDownLine />
                </div>
            ), renderCell: (params) =>
            (<div>

                <IconButton
                    color="primary"
                    onClick={() => { handleEdit(params.row) }}
                    sx={{ color: 'rgba(255,255,255,0.9)', '&:hover': { color: '#fff', backgroundColor: 'rgba(32,153,210,0.15) !important' } }}
                >
                    <Tooltip
                        title="Edit"
                        placement="top"
                        arrow
                    >
                        <EditOutlinedIcon fontSize="small" color="primary" />
                    </Tooltip>

                </IconButton>
                {user?.userRoles.split(",").includes("Super Admin") ?
                    <IconButton
                        color="error"
                        onClick={() => { handleDelete(params.row.stateId); }}
                        sx={{ color: 'rgba(255,255,255,0.9)', '&:hover': { color: '#fff', backgroundColor: 'rgba(211,48,47,0.15) !important' } }}
                    >
                        <Tooltip
                            title="Delete"
                            placement="top"
                            arrow
                        >
                            <DeleteOutlineOutlinedIcon fontSize="small" color="error" />
                        </Tooltip>

                    </IconButton>
                    : ""}
            </div>)
        },





    ];

    return (
        <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
            {loading && <LinearProgress sx={{ backgroundColor: "#132D3D" }} />}
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    gap: 1.5,
                    px: { xs: 4, lg: 2 },
                    py: 1.5,
                    borderBottom: '1px solid #e2e8f0',
                    backgroundColor: '#fafbfc',
                    minHeight: 56,
                    mb: 3,
                    marginLeft: { xs: '-24px', lg: '0px' },
                    marginRight: { xs: '-24px', lg: '0px' },
                }}
            >
                <h4 className="mb-0" style={{ fontWeight: 600, color: '#0f172a' }}>
                    States Zero Filing Rules
                </h4>
                <Button
                    variant="contained"
                    size="medium"
                    onClick={handleClickOpen}
                    startIcon={<Add />}
                    sx={{
                        textTransform: 'none',
                        fontWeight: 600,
                        backgroundColor: '#2099d2',
                        '&:hover': { backgroundColor: '#176990' },
                    }}
                >
                    Add New
                </Button>
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: 0,
                    borderRadius: '12px',
                    overflow: 'hidden',
                    boxShadow: '0 4px 24px rgba(15, 23, 42, 0.08), 0 1px 3px rgba(15, 23, 42, 0.06)',
                    border: '1px solid #e2e8f0',
                    backgroundColor: '#ffffff',
                    height: 'calc(100vh - 250px)',
                }}
            >
                <DataGridPro
                    getRowId={(r) => r.stateId}
                    rows={StateZeroFilingRuleCL}
                    columns={columns}
                    pageSize={50}
                    rowsPerPageOptions={[50]}
                    components={{
                        Toolbar: EditToolbar,
                    }}
                    // style={{ textAlign: 'center' }}
                    onSortModelChange={(newSortModel: any) => setSortModel(newSortModel)}
                    sortModel={sortModel}
                    sx={{
                        fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
                        border: 'none',
                        fontSize: '14px',
                        color: '#475569',
                        backgroundColor: '#ffffff',
                        '& .MuiDataGridPro-columnHeaderTitle': {
                            whiteSpace: 'normal',
                            lineHeight: 1.35,
                            fontWeight: 600,
                            fontSize: '12px',
                            letterSpacing: '0.05em',
                            textTransform: 'uppercase',
                            color: '#64748b',
                        },
                        '& .MuiDataGrid-columnHeaders': {
                            backgroundColor: '#f8fafc',
                            borderBottom: '2px solid #e2e8f0',
                            borderTop: '2px solid #e2e8f0',
                            minHeight: '52px !important',
                            maxHeight: '52px !important',
                        },
                        '& .MuiDataGrid-columnHeader': {
                            '&:focus, &:focus-within': { outline: 'none' },
                        },
                        '& .MuiDataGrid-row': {
                            transition: 'background-color 0.15s ease',
                            '&:nth-of-type(even)': {
                                backgroundColor: '#fafbfc',
                            },
                            '&:hover': {
                                backgroundColor: '#f1f5f9 !important',
                            },
                        },
                        '& .MuiDataGrid-cell': {
                            borderBottom: '1px solid #f1f5f9',
                            fontSize: '14px',
                            color: '#334155',
                            overflow: 'visible',
                            whiteSpace: 'normal',
                            lineHeight: 'normal',
                            wordWrap: 'break-word',
                            textOverflow: 'clip',
                            padding: '8px 16px',
                            '&:focus': { outline: 'none' },
                        },
                        '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
                            marginBottom: '0px !important',
                        },
                        '& .MuiDataGrid-virtualScroller': {
                            border: 'none',
                        },
                        '& .MuiDataGrid-main': {
                            border: 'none',
                        },
                        '& .MuiDataGrid-footerContainer': {
                            borderTop: '1px solid #e2e8f0',
                            backgroundColor: '#f8fafc',
                            minHeight: 56,
                        },
                        '& .MuiTablePagination-root': {
                            color: '#64748b',
                            fontSize: '13px',
                        },
                        '& .MuiTablePagination-select': {
                            fontSize: '13px',
                            borderRadius: '6px',
                            border: '1px solid #e2e8f0',
                        },
                        '& .MuiIconButton-root': {
                            color: '#64748b',
                            '&:hover': {
                                backgroundColor: '#f1f5f9',
                                color: '#475569',
                            },
                        },
                    }}
                />
            </Box>
            <EditStateZeroFilingRuleMatrix handleClose={handleClose} Open={Open} StateZeroRuleMatrixCL={Formdata} handleSubmit={handleSubmit} initValues={initialLBData} />
        </div>
    )
}